module.exports = __webpack_public_path__ + "img/part-3-title.4604b4e0.png";